import { connect } from 'react-redux';
import View from '../SummaryView';
import advWorkflowComponentSelector from '../../AdvWorkflow/AdvWorkflowComponentSelector';
import { WORKFLOW_ID } from '../../RetirementWorkflow/RetirementWorkflowConstants';

const mapStateToProps = (state, ownProps) => {
  const workflowIdAugmentedProps = {
    ...ownProps,
    workflowId: WORKFLOW_ID,
  };
  return {
    ...workflowIdAugmentedProps,
    Workflow: advWorkflowComponentSelector(state, workflowIdAugmentedProps),
  };
};

export default connect(mapStateToProps)(View);
